export const reactions: Record<string, string> = {
    heart: '❤️',
    party: '🎉',
    happy: '😄',
    like: '👍',
    sad: '😕',
    dislike: '👎',
};